import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import ProductChip from "../automations/ProductChip";

const id = "modal-turn-off-automation";
const CHOICES = ["keep", "remove"];

// Turning an automation off asks what happens to the people who are part-way through it
const TurnOffAutomation = ({ detail, returnTo }) => {
  const { t } = useTranslation("coaching-portal");
  const [people, setPeople] = useState("keep");
  const tr = (key, options) => t(`emailAutomations.turnOff.${key}`, options);
  const { automation, peopleInside } = detail ?? {};
  if (!automation) return null;

  return (
    <form
      action={`/actions/automations/${automation._id}/status`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="status" value="paused" />
      <input type="hidden" name="returnTo" value={returnTo} />
      <Modal
        name={id}
        key={id}
        className="ea-modal ea-modal--turn-off"
        customTitle={
          <h2 className="ea-modal__title">
            {tr("title", { name: automation.name })}
            <ProductChip product={automation.product} />
          </h2>
        }
      >
        <div className="body">
          <p className="ea-modal__lead">
            {peopleInside > 0
              ? tr("people", { count: peopleInside })
              : tr("none")}
          </p>
          {peopleInside > 0 ? (
            <fieldset className="ea-choices">
              <legend className="sr-only">
                {tr("title", { name: automation.name })}
              </legend>
              {CHOICES.map((choice) => (
                <label
                  key={choice}
                  className={`ea-choice${people === choice ? " ea-choice--selected" : ""}`}
                >
                  <input
                    type="radio"
                    name="people"
                    value={choice}
                    className="sr-only"
                    checked={people === choice}
                    onChange={() => setPeople(choice)}
                  />
                  <i className="ea-choice__radio" aria-hidden="true" />
                  <strong>
                    {tr(`${choice === "keep" ? "pause" : "stop"}.title`)}
                  </strong>
                  <span>
                    {tr(`${choice === "keep" ? "pause" : "stop"}.body`)}
                  </span>
                </label>
              ))}
            </fieldset>
          ) : null}
        </div>
        <footer className="foot">
          {/* biome-ignore lint/a11y/useSemanticElements: a real link so Rill navigates; role only picks up button styles */}
          <a
            href="/actions/refresh?modal=&automation="
            data-button-type="secondary"
            data-action="cancel"
            role="button"
          >
            {tr("cancel")}
          </a>
          <button type="submit" data-button-type="primary">
            {tr("confirm")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

TurnOffAutomation.propTypes = {
  detail: PropTypes.shape({
    automation: PropTypes.object,
    peopleInside: PropTypes.number,
  }),
  returnTo: PropTypes.string.isRequired,
};

export default TurnOffAutomation;
